



























































import { Component, Prop, Vue } from "vue-property-decorator";
import mdui from "mdui";

@Component
export default class bookCard extends Vue {
  @Prop() private item: any;
  @Prop() private remove: any;
  private timeOutEvent: any;
  private set: boolean = true;
  private CR: string = '&#13;'

  public openMenu(head: any, who: any): void {
    //调用id
    const open: string = head + who;
    let menu: string = "#m" + who; //#whoM
    //参数
    var options: any = {
      position: "top",
      align: "left",
      covered: "false",
      fixed: "true",
    };
    // 判断是否已经有menu打开，因为用的是右键menu不会自动关闭
    if (this.$store.state.menu != null) {
      this.$store.state.menu.close();
    }
    this.$store.commit("setMenu", new mdui.Menu(open, menu, options));
    this.$store.state.menu.open();
  }

  public openLink(link: string) {
    window.open(link, "_blank");
  }

  public openMove() {
    this.$emit("setMdMove");
  }

  public setHoverTitle(item:any):string {
    return item.title+"\n"+item.url
  }

  // 修改标题
  public setTitle(item: any) {
    // 其他参数
    var optione: any = {
      maxlength: 100,
      cancelText: "取消",
      defaultValue: item.title,
    };
    // @ts-ignore
    var http = this.$httpService; //创建对象防止回调函数找不到
    // @ts-ignore
    var store = this.$store;
    mdui.prompt(
      "请输入新的标题",
      function (value) {
        var newTitle = JSON.stringify({
          navigationId: item.indexId,
          title: value,
        });
        // @ts-ignore
        http.postData(newTitle, true, "updateTitle", "application/json").then(
          (result: any) => {
            // @ts-ignore
            store.commit("getMarkList");
          },
          (error: any) => {}
        );
      },
      function () {},
      optione
    );
  }

  //删除
  public removeUrl(item: any) {
    this.$emit("deleteItem", item.indexId);
    var data = JSON.stringify({
      urlId: item.urlId,
      indexId: item.indexId,
    });
    // @ts-ignore
    this.$httpService
      .postData(data, true, "deleteMark", "application/json")
      .then(
        (result: any) => {
          // @ts-ignore
          this.$store.commit("getMarkList");
        },
        (error: any) => {}
      );
  }
  // 批量删除
  public openRemove() {
    // this.$parent.openRemove()
    this.$emit("openRemove");
  }

  // 网络请求

  public gtouchStart() {
    this.timeOutEvent = setTimeout(() => {
      // 振动
      // if (navigator.vibrate) {
      //   navigator.vibrate(50);
      // } else if (navigator.webkitVibrate) {
      //   navigator.webkitVibrate(50);
      // }
      var r = confirm("是否进入编辑模式!");
      if (r) {
        this.set = true;
        this.openMenu("#o", this.item.indexId);
      }
      this.timeOutEvent = 300;
    }, 300);
    (window as any).event.stopPropagation();
  }

  public gtouchEnd() {
    if (this.set == true) {
      clearTimeout(this.timeOutEvent); //清除定时器
    }
  }

  public gtouchMove() {
    clearTimeout(this.timeOutEvent); //清除定时器
    this.timeOutEvent = 0;
  }
}
